import { useState } from 'react';

import { OrderOperationType } from 'api/types/entity';
import { ConfirmationDialog } from 'components';
import { useTranslation } from 'libs/i18n';
import { ROUTES, useNavigate } from 'libs/navigation';
import { Autocomplete, DialogStateProps } from 'libs/ui';
import { OrderOperationTypeForSearchParams } from 'modules/order/createOrder/types';

interface Props extends DialogStateProps {}

export const DialogCreateOrder = ({ isOpen, onClose }: Props) => {
  const { t } = useTranslation();

  const { navigate } = useNavigate();

  const [orderType, setOrderType] = useState<OrderOperationType | null>(null);

  const handleClose = () => {
    setOrderType(null);
    onClose?.();
  };

  const onConfirm = () => {
    if (!orderType) return;

    navigate(
      ROUTES.orders.createOrder.fullPath,
      {},
      { search: { type: OrderOperationTypeForSearchParams[orderType] } }
    );
    handleClose();
  };

  return (
    <ConfirmationDialog
      fullWidth
      headerCentered
      confirmButtonDisabled={!orderType}
      confirmButtonLabel={t('common.continue')}
      isOpen={isOpen}
      maxWidth="sm"
      subtitle={t('order.orders.createOrderDialog.subtitle')}
      title={t('order.orders.createOrderDialog.title')}
      onBack={handleClose}
      onClose={handleClose}
      onConfirm={onConfirm}
    >
      <Autocomplete
        showRequiredMark
        label={t('order.orders.createOrderDialog.orderType.label')}
        optionLabelKey="label"
        options={Object.values(OrderOperationType).map((type) => ({
          label: t(`order.operationTypes.${type}`),
          value: type,
        }))}
        optionValueKey="value"
        placeholder={t('order.orders.createOrderDialog.orderType.placeholder')}
        value={
          orderType
            ? {
                label: t(`order.operationTypes.${orderType}`),
                value: orderType,
              }
            : null
        }
        onChange={(_, value) => setOrderType(value?.value || null)}
      />
    </ConfirmationDialog>
  );
};
